import instance from "../../api"

export const getEmployeeInfo = (userId: string) => {
    return instance().post("employeeReport/employeeInfo", { userId }).then(response => response.data);
}